import _definePage_default_0 from '/portail-vue/src/pages/index.vue?definePage&vue&lang.tsx'
import _page_1 from '/portail-vue/src/pages/index.vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _page_3 from '/portail-vue/src/pages/[...all].vue'
import _definePage_default_4 from '/portail-vue/src/pages/accueil.vue?definePage&vue&lang.tsx'
import _page_5 from '/portail-vue/src/pages/accueil.vue'
import _definePage_default_6 from '/portail-vue/src/pages/admin.vue?definePage&vue&lang.tsx'
import _page_7 from '/portail-vue/src/pages/admin.vue'
import _definePage_default_8 from '/portail-vue/src/pages/admin/alertes.vue?definePage&vue&lang.tsx'
import _page_9 from '/portail-vue/src/pages/admin/alertes.vue'
import _definePage_default_10 from '/portail-vue/src/pages/admin/gestion.vue?definePage&vue&lang.tsx'
import _page_11 from '/portail-vue/src/pages/admin/gestion.vue'
import _definePage_default_12 from '/portail-vue/src/pages/alertes.vue?definePage&vue&lang.tsx'
import _page_13 from '/portail-vue/src/pages/alertes.vue'
import _definePage_default_14 from '/portail-vue/src/pages/capteurs.vue?definePage&vue&lang.tsx'
import _page_15 from '/portail-vue/src/pages/capteurs.vue'
import _definePage_default_16 from '/portail-vue/src/pages/capteurs/compteurseau.vue?definePage&vue&lang.tsx'
import _page_17 from '/portail-vue/src/pages/capteurs/compteurseau.vue'
import _definePage_default_18 from '/portail-vue/src/pages/capteurs/meteo.vue?definePage&vue&lang.tsx'
import _page_19 from '/portail-vue/src/pages/capteurs/meteo.vue'
import _definePage_default_20 from '/portail-vue/src/pages/capteurs/temphumidite.vue?definePage&vue&lang.tsx'
import _page_21 from '/portail-vue/src/pages/capteurs/temphumidite.vue'
import _definePage_default_22 from '/portail-vue/src/pages/carte.vue?definePage&vue&lang.tsx'
import _page_23 from '/portail-vue/src/pages/carte.vue'
import _definePage_default_24 from '/portail-vue/src/pages/changelog.vue?definePage&vue&lang.tsx'
import _page_25 from '/portail-vue/src/pages/changelog.vue'
import _definePage_default_26 from '/portail-vue/src/pages/dev/appareils.vue?definePage&vue&lang.tsx'
import _page_27 from '/portail-vue/src/pages/dev/appareils.vue'
import _definePage_default_28 from '/portail-vue/src/pages/dev/consommationeau.vue?definePage&vue&lang.tsx'
import _page_29 from '/portail-vue/src/pages/dev/consommationeau.vue'
import _definePage_default_30 from '/portail-vue/src/pages/dev/dashboard.vue?definePage&vue&lang.tsx'
import _page_31 from '/portail-vue/src/pages/dev/dashboard.vue'
import _definePage_default_32 from '/portail-vue/src/pages/dev/httpdevices.vue?definePage&vue&lang.tsx'
import _page_33 from '/portail-vue/src/pages/dev/httpdevices.vue'
import _definePage_default_34 from '/portail-vue/src/pages/dev/httpdevices.[customerId].[id].vue?definePage&vue&lang.tsx'
import _page_35 from '/portail-vue/src/pages/dev/httpdevices.[customerId].[id].vue'
import _definePage_default_36 from '/portail-vue/src/pages/dev/jsonforms.vue?definePage&vue&lang.tsx'
import _page_37 from '/portail-vue/src/pages/dev/jsonforms.vue'
import _definePage_default_38 from '/portail-vue/src/pages/dev/thingsboard.vue?definePage&vue&lang.tsx'
import _page_39 from '/portail-vue/src/pages/dev/thingsboard.vue'
import _definePage_default_40 from '/portail-vue/src/pages/ferme.vue?definePage&vue&lang.tsx'
import _page_41 from '/portail-vue/src/pages/ferme.vue'
import _definePage_default_42 from '/portail-vue/src/pages/ferme/degrejour.vue?definePage&vue&lang.tsx'
import _page_43 from '/portail-vue/src/pages/ferme/degrejour.vue'
import _definePage_default_44 from '/portail-vue/src/pages/ferme/planificateur.vue?definePage&vue&lang.tsx'
import _page_45 from '/portail-vue/src/pages/ferme/planificateur.vue'
import _definePage_default_46 from '/portail-vue/src/pages/ferme/semis.vue?definePage&vue&lang.tsx'
import _page_47 from '/portail-vue/src/pages/ferme/semis.vue'
import _definePage_default_48 from '/portail-vue/src/pages/ferme/test-tableau.vue?definePage&vue&lang.tsx'
import _page_49 from '/portail-vue/src/pages/ferme/test-tableau.vue'
import _definePage_default_50 from '/portail-vue/src/pages/login.vue?definePage&vue&lang.tsx'
import _page_51 from '/portail-vue/src/pages/login.vue'
import _definePage_default_52 from '/portail-vue/src/pages/ott/temp.vue?definePage&vue&lang.tsx'
import _page_53 from '/portail-vue/src/pages/ott/temp.vue'
import _definePage_default_54 from '/portail-vue/src/pages/ott/test.vue?definePage&vue&lang.tsx'
import _page_55 from '/portail-vue/src/pages/ott/test.vue'
import _definePage_default_56 from '/portail-vue/src/pages/ott/wmeters.vue?definePage&vue&lang.tsx'
import _page_57 from '/portail-vue/src/pages/ott/wmeters.vue'
import _definePage_default_58 from '/portail-vue/src/pages/prisme.vue?definePage&vue&lang.tsx'
import _page_59 from '/portail-vue/src/pages/prisme.vue'
import _definePage_default_60 from '/portail-vue/src/pages/prisme/capteurs-spores.vue?definePage&vue&lang.tsx'
import _page_61 from '/portail-vue/src/pages/prisme/capteurs-spores.vue'
import _definePage_default_62 from '/portail-vue/src/pages/prisme/captures-spores.vue?definePage&vue&lang.tsx'
import _page_63 from '/portail-vue/src/pages/prisme/captures-spores.vue'
import _definePage_default_64 from '/portail-vue/src/pages/prisme/donnees-meteo.vue?definePage&vue&lang.tsx'
import _page_65 from '/portail-vue/src/pages/prisme/donnees-meteo.vue'
import _definePage_default_66 from '/portail-vue/src/pages/prisme/oignonbotrytis.vue?definePage&vue&lang.tsx'
import _page_67 from '/portail-vue/src/pages/prisme/oignonbotrytis.vue'
import _definePage_default_68 from '/portail-vue/src/pages/vegco.vue?definePage&vue&lang.tsx'
import _page_69 from '/portail-vue/src/pages/vegco.vue'
import _definePage_default_70 from '/portail-vue/src/pages/vegco/bucketssem.vue?definePage&vue&lang.tsx'
import _page_71 from '/portail-vue/src/pages/vegco/bucketssem.vue'
import _definePage_default_72 from '/portail-vue/src/pages/vegco/commandes.vue?definePage&vue&lang.tsx'
import _page_73 from '/portail-vue/src/pages/vegco/commandes.vue'
import _definePage_default_74 from '/portail-vue/src/pages/vegco/gestion.vue?definePage&vue&lang.tsx'
import _page_75 from '/portail-vue/src/pages/vegco/gestion.vue'
import _definePage_default_76 from '/portail-vue/src/pages/vegco/grl.vue?definePage&vue&lang.tsx'
import _page_77 from '/portail-vue/src/pages/vegco/grl.vue'
import _definePage_default_78 from '/portail-vue/src/pages/vegco/palettes.vue?definePage&vue&lang.tsx'
import _page_79 from '/portail-vue/src/pages/vegco/palettes.vue'
import _definePage_default_80 from '/portail-vue/src/pages/vegco/quarantaines.vue?definePage&vue&lang.tsx'
import _page_81 from '/portail-vue/src/pages/vegco/quarantaines.vue'
import _definePage_default_82 from '/portail-vue/src/pages/vegco/rapportproducteurs.vue?definePage&vue&lang.tsx'
import _page_83 from '/portail-vue/src/pages/vegco/rapportproducteurs.vue'
import _definePage_default_84 from '/portail-vue/src/pages/vegco/rapportsemaine.vue?definePage&vue&lang.tsx'
import _page_85 from '/portail-vue/src/pages/vegco/rapportsemaine.vue'
import _definePage_default_86 from '/portail-vue/src/pages/vegco/recoltes.vue?definePage&vue&lang.tsx'
import _page_87 from '/portail-vue/src/pages/vegco/recoltes.vue'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: _page_1,
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: _page_3,
    /* no children */
  },
  _mergeRouteRecord(
    {
      path: '/accueil',
      name: '/accueil',
      component: _page_5,
      /* no children */
    },
    _definePage_default_4
  ),
  _mergeRouteRecord(
    {
      path: '/admin',
      name: '/admin',
      component: _page_7,
      children: [
        _mergeRouteRecord(
          {
            path: 'alertes',
            name: '/admin/alertes',
            component: _page_9,
            /* no children */
          },
          _definePage_default_8
        ),
        _mergeRouteRecord(
          {
            path: 'gestion',
            name: '/admin/gestion',
            component: _page_11,
            /* no children */
          },
          _definePage_default_10
        )
      ],
    },
    _definePage_default_6
  ),
  _mergeRouteRecord(
    {
      path: '/alertes',
      name: '/alertes',
      component: _page_13,
      /* no children */
    },
    _definePage_default_12
  ),
  _mergeRouteRecord(
    {
      path: '/capteurs',
      name: '/capteurs',
      component: _page_15,
      children: [
        _mergeRouteRecord(
          {
            path: 'compteurseau',
            name: '/capteurs/compteurseau',
            component: _page_17,
            /* no children */
          },
          _definePage_default_16
        ),
        _mergeRouteRecord(
          {
            path: 'meteo',
            name: '/capteurs/meteo',
            component: _page_19,
            /* no children */
          },
          _definePage_default_18
        ),
        _mergeRouteRecord(
          {
            path: 'temphumidite',
            name: '/capteurs/temphumidite',
            component: _page_21,
            /* no children */
          },
          _definePage_default_20
        )
      ],
    },
    _definePage_default_14
  ),
  _mergeRouteRecord(
    {
      path: '/carte',
      name: '/carte',
      component: _page_23,
      /* no children */
    },
    _definePage_default_22
  ),
  _mergeRouteRecord(
    {
      path: '/changelog',
      name: '/changelog',
      component: _page_25,
      /* no children */
    },
    _definePage_default_24
  ),
  {
    path: '/dev',
    /* internal name: '/dev' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'appareils',
          name: '/dev/appareils',
          component: _page_27,
          /* no children */
        },
        _definePage_default_26
      ),
      _mergeRouteRecord(
        {
          path: 'consommationeau',
          name: '/dev/consommationeau',
          component: _page_29,
          /* no children */
        },
        _definePage_default_28
      ),
      _mergeRouteRecord(
        {
          path: 'dashboard',
          name: '/dev/dashboard',
          component: _page_31,
          /* no children */
        },
        _definePage_default_30
      ),
      _mergeRouteRecord(
        {
          path: 'httpdevices',
          name: '/dev/httpdevices',
          component: _page_33,
          /* no children */
        },
        _definePage_default_32
      ),
      _mergeRouteRecord(
        {
          path: 'httpdevices/:customerId/:id',
          name: '/dev/httpdevices.[customerId].[id]',
          component: _page_35,
          /* no children */
        },
        _definePage_default_34
      ),
      _mergeRouteRecord(
        {
          path: 'jsonforms',
          name: '/dev/jsonforms',
          component: _page_37,
          /* no children */
        },
        _definePage_default_36
      ),
      _mergeRouteRecord(
        {
          path: 'thingsboard',
          name: '/dev/thingsboard',
          component: _page_39,
          /* no children */
        },
        _definePage_default_38
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/ferme',
      name: '/ferme',
      component: _page_41,
      children: [
        _mergeRouteRecord(
          {
            path: 'degrejour',
            name: '/ferme/degrejour',
            component: _page_43,
            /* no children */
          },
          _definePage_default_42
        ),
        _mergeRouteRecord(
          {
            path: 'planificateur',
            name: '/ferme/planificateur',
            component: _page_45,
            /* no children */
          },
          _definePage_default_44
        ),
        _mergeRouteRecord(
          {
            path: 'semis',
            name: '/ferme/semis',
            component: _page_47,
            /* no children */
          },
          _definePage_default_46
        ),
        _mergeRouteRecord(
          {
            path: 'test-tableau',
            name: '/ferme/test-tableau',
            component: _page_49,
            /* no children */
          },
          _definePage_default_48
        )
      ],
    },
    _definePage_default_40
  ),
  _mergeRouteRecord(
    {
      path: '/login',
      name: '/login',
      component: _page_51,
      /* no children */
    },
    _definePage_default_50
  ),
  {
    path: '/ott',
    /* internal name: '/ott' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'temp',
          name: '/ott/temp',
          component: _page_53,
          /* no children */
        },
        _definePage_default_52
      ),
      _mergeRouteRecord(
        {
          path: 'test',
          name: '/ott/test',
          component: _page_55,
          /* no children */
        },
        _definePage_default_54
      ),
      _mergeRouteRecord(
        {
          path: 'wmeters',
          name: '/ott/wmeters',
          component: _page_57,
          /* no children */
        },
        _definePage_default_56
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/prisme',
      name: '/prisme',
      component: _page_59,
      children: [
        _mergeRouteRecord(
          {
            path: 'capteurs-spores',
            name: '/prisme/capteurs-spores',
            component: _page_61,
            /* no children */
          },
          _definePage_default_60
        ),
        _mergeRouteRecord(
          {
            path: 'captures-spores',
            name: '/prisme/captures-spores',
            component: _page_63,
            /* no children */
          },
          _definePage_default_62
        ),
        _mergeRouteRecord(
          {
            path: 'donnees-meteo',
            name: '/prisme/donnees-meteo',
            component: _page_65,
            /* no children */
          },
          _definePage_default_64
        ),
        _mergeRouteRecord(
          {
            path: 'oignonbotrytis',
            name: '/prisme/oignonbotrytis',
            component: _page_67,
            /* no children */
          },
          _definePage_default_66
        )
      ],
    },
    _definePage_default_58
  ),
  _mergeRouteRecord(
    {
      path: '/vegco',
      name: '/vegco',
      component: _page_69,
      children: [
        _mergeRouteRecord(
          {
            path: 'bucketssem',
            name: '/vegco/bucketssem',
            component: _page_71,
            /* no children */
          },
          _definePage_default_70
        ),
        _mergeRouteRecord(
          {
            path: 'commandes',
            name: '/vegco/commandes',
            component: _page_73,
            /* no children */
          },
          _definePage_default_72
        ),
        _mergeRouteRecord(
          {
            path: 'gestion',
            name: '/vegco/gestion',
            component: _page_75,
            /* no children */
          },
          _definePage_default_74
        ),
        _mergeRouteRecord(
          {
            path: 'grl',
            name: '/vegco/grl',
            component: _page_77,
            /* no children */
          },
          _definePage_default_76
        ),
        _mergeRouteRecord(
          {
            path: 'palettes',
            name: '/vegco/palettes',
            component: _page_79,
            /* no children */
          },
          _definePage_default_78
        ),
        _mergeRouteRecord(
          {
            path: 'quarantaines',
            name: '/vegco/quarantaines',
            component: _page_81,
            /* no children */
          },
          _definePage_default_80
        ),
        _mergeRouteRecord(
          {
            path: 'rapportproducteurs',
            name: '/vegco/rapportproducteurs',
            component: _page_83,
            /* no children */
          },
          _definePage_default_82
        ),
        _mergeRouteRecord(
          {
            path: 'rapportsemaine',
            name: '/vegco/rapportsemaine',
            component: _page_85,
            /* no children */
          },
          _definePage_default_84
        ),
        _mergeRouteRecord(
          {
            path: 'recoltes',
            name: '/vegco/recoltes',
            component: _page_87,
            /* no children */
          },
          _definePage_default_86
        )
      ],
    },
    _definePage_default_68
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

